export default __webpack_public_path__ + "exp-icon14c11b2.png";